import { signal } from "@angular/core";
import { SchemaPathTree } from "@angular/forms/signals";

export interface EnergyLabelModel {
    energyLabel: string;
    index: number;
    selected: boolean;
}

const defaultEnergyLabels: EnergyLabelModel[] = [
    { energyLabel: "A", index: 0, selected: false },
    { energyLabel: "B", index: 1, selected: false },
    { energyLabel: "C", index: 2, selected: false },
    { energyLabel: "D", index: 3, selected: false },
    { energyLabel: "E", index: 4, selected: false },
    { energyLabel: "F", index: 5, selected: false },
    { energyLabel: "G", index: 6, selected: false },
];

export interface EnergyLabelsFilterModel {
    energyLabels: EnergyLabelModel[];
    expanded: boolean;
}

export function createEnergyLabelsModel() {
    return signal<EnergyLabelsFilterModel>({
        energyLabels: defaultEnergyLabels,
        expanded: false,
    });
}

export function buildEnergyLabelsModel(a: SchemaPathTree<EnergyLabelsFilterModel>) {}
